import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { BottomSheetExpandStates, BottomSheetUiConfig } from '../shared/models/bottom-sheet.types';


@Injectable({
  providedIn: 'root'
})
export class BottomSheetDataService {

  private readonly PERSISTED_BOTTOM_SHEET_EXPANDED_STATE_KEY = "PERSISTED_BOTTOM_SHEET_EXPANDED_STATE_KEY";
  private readonly PERSISTED_BOTTOM_SHEET_UI_CONFIG_KEY = "PERSISTED_BOTTOM_SHEET_UI_CONFIG_KEY";

  public readonly bottomSheetExpandedState: Signal<BottomSheetExpandStates>;
  public readonly bottomSheetUiConfig: Signal<BottomSheetUiConfig>;

  private _expandedStateSignal: WritableSignal<BottomSheetExpandStates>;
  private _uiConfigSignal: WritableSignal<BottomSheetUiConfig>;

  constructor() {
    // Restore from sessionStorage (Insights Dashboard – e.g. Customer Report panel state).
    let persistedBottomSheetState: BottomSheetExpandStates = 'hidden';
    let persistedBottomSheetUiConfig: string | null = null;
    try {
      const storedState = sessionStorage.getItem(this.PERSISTED_BOTTOM_SHEET_EXPANDED_STATE_KEY);
      const storedConfig = sessionStorage.getItem(this.PERSISTED_BOTTOM_SHEET_UI_CONFIG_KEY);
      if (storedState) persistedBottomSheetState = storedState as BottomSheetExpandStates;
      if (storedConfig) persistedBottomSheetUiConfig = storedConfig;
    } catch (e) {
      // ignore
    }

    this._expandedStateSignal = signal<BottomSheetExpandStates>(persistedBottomSheetState);
    this._uiConfigSignal = signal<BottomSheetUiConfig>(persistedBottomSheetUiConfig ? JSON.parse(persistedBottomSheetUiConfig): null);

    this.bottomSheetUiConfig = this._uiConfigSignal.asReadonly();
    this.bottomSheetExpandedState = this._expandedStateSignal.asReadonly();
  }

  setBottomSheetExpandedState(newState: BottomSheetExpandStates) {
    try {
      sessionStorage.setItem(this.PERSISTED_BOTTOM_SHEET_EXPANDED_STATE_KEY, newState);
    } catch (e) {
      // ignore
    }
    this._expandedStateSignal.set(newState);
  }

  setBottomSheetUiConfig(config: BottomSheetUiConfig) {
    try {
      sessionStorage.setItem(this.PERSISTED_BOTTOM_SHEET_UI_CONFIG_KEY, JSON.stringify(config));
    } catch (e) {
      // ignore
    }
    this._uiConfigSignal.set(config);
  }
}
